import { locales } from '@/config/i18n';

export const matchLanguageToLocale: Record<string, Locale> = {
  'pt-BR': locales.ptBR,
  'en-US': locales.enUS,
  'es-ES': locales.es,
};
